import { useMutation, useQueryClient } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { UpdatePatientTreatmentScheduleActivityArgs } from "../schemas/Treatment";

import { queryKeyPrefix } from "./useGetPatientTreatmentScheduleWeek";

export const useDeletePatientTreatmentScheduleActivity = () => {
  const client = useApiClient();
  const queryClient = useQueryClient();

  return useMutation<void, Error, UpdatePatientTreatmentScheduleActivityArgs>({
    mutationFn: args => client.deletePatientTreatmentScheduleActivity(args),
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeyPrefix);
    },
  });
};
